export const findConsultantResultPageSize = 5;
